import React from 'react';
import { getText } from '@storebrand-digital/fms-translations';
import { CardHeadingGroup, CardNav } from '@storebrand-digital/pretzel';
import styles from './Dashboard.module.css';

function InsuranceArchive() {
  return (
    <div className={styles.otherArchivesContainer}>
      <div className="grid-container">
        <CardNav
          orientation="vertical"
          icon="invoice"
          className="grid-item lg_cols-6"
          aria-label={getText('otherArchive.faktura.label')}
        >
          {(ref) => (
            <CardHeadingGroup
              ref={ref}
              as="a"
              href={getText('otherArchive.faktura.href')}
              data-trackid={`link-faktura_archive|${getText(
                'otherArchive.faktura.label'
              )}`}
              heading={getText('otherArchive.faktura.label')}
              description={getText('otherArchive.faktura.caption')}
            />
          )}
        </CardNav>
      </div>
    </div>
  );
}

export default InsuranceArchive;
